'use strict'

var extend = require('extend');

function Slide(element, attributes) {
	this.element = element;
	this.attributes = extend({}, {
		imageSrc: undefined,
		altText: undefined,
		titleText: undefined,
		captionText: undefined
	}, attributes);

	this.imgFluid = document.createElement('img');
	this.imgFluid.setAttribute('class', 'fluid');
	this.imgFluid.setAttribute('src', 'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==');
	this.imgFluid.setAttribute('style', 'background-image: url(' + this.attributes.imageSrc + ');');
	this.imgFluid.setAttribute('alt', this.attributes.altText);
	this.imgFluid.setAttribute('title', this.attributes.titleText);

	if (this.attributes.captionText) {
		this.caption = document.createElement('figcaption');
		this.caption.setAttribute('class', 'gallery__caption');
		this.caption.textContent = this.attributes.captionText;
	}
}

Slide.prototype.appendElements = function (imgFrame, frame) {
	imgFrame.appendChild(this.imgFluid);

	if (this.caption)
		frame.appendChild(this.caption);
};

module.exports = Slide;
